import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CaseInformation.module.scss'
import { caseNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const CaseNumber = ({ t, validateCaseNumber, caseNumberError, caseNumberValid, caseNumberJEINError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const caseNumber = useSelector((state) => state.app.caseNumber)

  const handleCaseNumber = (e) => {
    try {
      let number = e.currentTarget.value
      dispatch(caseNumberAction(number))
      // validateCaseNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurCaseNumber = (e) => {
    try {
      let number = e.currentTarget.value.trim()
      SetIsFocussed(false)
      dispatch(caseNumberAction(number))
      validateCaseNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div className={styles['fields_margin']}>
      <div
        className={
          caseNumberValid === true
            ? caseNumber !== '' && 'form-group'
            : caseNumberValid === false && 'form-group ns-form-group-message-error'
        }
      >
        <label className="control-label" htmlFor="CaseNumber">
          <b>{t('case_information.case_number')}</b>
        </label>
        {caseNumberValid === false && (
          <div className="ns-form-error-container has-error error-msg-align">
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>
              {caseNumberJEINError ? caseNumberJEINError : t(caseNumberError)}
            </div>
          </div>
        )}
        <input
          autoFocus
          type="text"
          id="CaseNumber"
          className={['form-control', styles['field_width']].join(' ')}
          value={caseNumber}
          onChange={handleCaseNumber}
          // onBlur={onBlurCaseNumber}
          onFocus={() => SetIsFocussed(true)}
          autoComplete="off"
          maxLength="10"
        />
        {/* {caseNumberValid === true && caseNumber !== '' && (
          <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
        )} */}
      </div>
    </div>
  )
}

export default withTranslation('common')(CaseNumber)
